// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__63Fap","tableExams":"styles_tableExams__wN+80","tableExams_thead":"styles_tableExams_thead__2s+R6","tableExams_tbody":"styles_tableExams_tbody__LyUcX"};